<template>
	<StandardModal
		open
		:title="$t('admin_people_person_added_label')"
		ref="personadded"
		class="person-added"
	>
		<div class="top-content">
			<UserCheckIcon class="user-check-icon" halo />
			<div class="top-title">
				{{
					$t('admin_people_added_person_success_label', {
						UserName: user.fullname,
					})
				}}
			</div>
		</div>
		<div class="actions">
			<div class="actions-label" v-t="'admin_groups_next_steps'" />
			<RouterLink
				class="action-item"
				v-for="action in successActions"
				:key="action.id"
				:to="action.link"
			>
				<div>
					<component :is="action.icon" />
					{{ $t(action.text) }}
				</div>
				<div class="action-link" v-text="$t(action.linkText)" />
			</RouterLink>
		</div>

		<template #cancel
			><Button @click="$emit('addPerson')">{{
				$t('admin_people_add_another_person_button')
			}}</Button></template
		>
		<template #confirm
			><Button primary @click="done">{{
				$t('common_button_done')
			}}</Button></template
		>
	</StandardModal>
</template>

<script>
import { StandardModal, Button } from '@/components/common'
import { UserCheckIcon, GroupsIcon, DetailsIcon } from '@/icons'

export default {
	components: { StandardModal, Button, UserCheckIcon, GroupsIcon, DetailsIcon },
	props: ['user'],

	computed: {
		successActions() {
			return [
				{
					icon: GroupsIcon,
					text: 'admin_people_add_person_group_button',
					linkText: 'admin_people_add_to_groups_button',
					link: `/organization/users/${this.user.id}?groups=true`,
				},
				{
					icon: DetailsIcon,
					text: 'admin_people_view_person_details_button',
					linkText: 'admin_categories_open_details_action',
					link: `/organization/users/${this.user.id}`,
				},
			]
		},
	},

	methods: {
		done() {
			this.$emit('done')
		},
	},

	emits: ['addPerson', 'done'],
}
</script>

<style lang="scss">
@import 'src/sass/variables';

.person-added {
	.modal-body {
		padding: 24px;
		.top-content {
			@include flex-column;
			align-items: center;
			margin-bottom: 56px;
			.top-title {
				font-family: Avenir-Heavy;
				font-size: 24px;
				text-align: center;
				margin: 0 100px;
			}
			.pronto-icon {
				font-size: 55px;
				color: var(--blue-300);
				margin-bottom: 24px;
			}
		}
		.actions {
			.actions-label {
				font-family: Avenir-Heavy;
				padding: 0 16px;
				margin-bottom: 8px;
			}
			.action-item {
				@include flex-spread;
				height: 50px;
				border-radius: 6px;
				padding: 0 16px;
				cursor: pointer;
				margin-bottom: 8px;
				color: inherit;
				text-decoration: none;
				&:hover {
					background: rgba($pronto-blue, 0.1);
				}
				> div {
					@include flex;
				}
				.pronto-icon {
					color: var(--blue-300);
					font-size: 20px;
					margin-right: 12px;
				}
				.action-link {
					color: var(--blue-300);
				}
			}
		}

		.user-check-icon {
			font-size: 66px !important;
		}
	}
}
</style>
